<form [formGroup]="coverageFormGroup" class="d-inline-flex w-100">
  <div class="mb-3 col-6 pe-3">
    <mat-form-field appearance="outline">
      @if (coverageTab?.enrollReasonForDisplay) {
        <mat-label>{{ coverageTab?.enrollReasonForDisplay }}
        </mat-label>
      }
      <mat-select formControlName="enrollReasonID">
        @for (reason of coverageTab.enrollReasonCollection; track reason) {
          <mat-option [value]="reason.id" (onSelectionChange)="reasonChanged(reason)">
            {{ reason?.description }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
  @if (requireAdditionalText) {
    <div class="col-6 mb-3">
      <mwp-input [form]="coverageFormGroup" [labelName]="additionalText" nameForControl="enrollReasonAdditional" />
    </div>
  }
</form>